import { SxProps, Theme, Button } from '@mui/material';
import { useState, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Brands, Customer, IStoreTellerModelInput, Product } from 'shared/types';
import { copyToClipboard } from 'shared/utility';

enum ButtonStates {
  Default = 'Get Model Inputs',
  Clicked = 'Copied!',
}

interface IProps {
  index: number;
}

const modelInputButtonStyles: SxProps<Theme> = {
  minWidth: '170px',
};

const TWO_SECONDS = 2000;

export function ProductCardModelInputsButton({ index }: IProps) {
  const [buttonText, setButtonText] = useState<ButtonStates>(ButtonStates.Default);
  const { getValues } = useFormContext();
  const { brand } = useParams<{ brand: Brands }>();

  const product: Product = useMemo(() => getValues().products[index], [index, getValues]);
  const customer: Customer = useMemo(() => getValues().customer, [getValues]);

  const handleClick = () => {
    const storeTellerModel: IStoreTellerModelInput = {
      modelInputs: {
        customerNumber: customer.customerNumber,
        competitiveFactor: customer.customerType,
        competition: customer.competition,
        childCustomer: customer.customerNumber || '00000',
        brand,
        marginParams: [
          {
            productGuid: product.productGuid,
            ItemID: product.itemId || 'NEW PRODUCT',
            VendorID: product.vendorId,
            ProductType: product.productType,
            ItemDescription: product.itemDescriptionAdj || 'NEW PRODUCT',
            Cost:
              brand === 'cbe'
                ? Number(product.lastCostPaid) * Number(product.exchangerate)
                : Number(product.lastCostPaid),
            ListMargin: product.marginAtList,
            ListPrice: product.listPrice || 0,
            PremiumHistoricalMargin: product.marginPercentileEighty,
            MROvsCapital: product.MROvsCapital || 'NOT APPLICABLE',
            FactorSheetName: product.factorSheetName || 'NOT APPLICABLE',
          },
        ],
      },
      includeInResponse: [product.productGuid],
    };
    copyToClipboard(JSON.stringify(storeTellerModel));
    updateButtonText();
  };

  const updateButtonText = () => {
    setButtonText(ButtonStates.Clicked);
    setTimeout(() => {
      setButtonText(ButtonStates.Default);
    }, TWO_SECONDS);
  };

  return (
    <Button type='button' variant='contained' color='secondary' sx={modelInputButtonStyles} onClick={handleClick}>
      {buttonText}
    </Button>
  );
}
